import React, { useState } from 'react';
import { Button } from "components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "components/ui/card";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { auth } from 'firebase-config';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export function JoinOrganizationPage() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmitCode = async () => {
    if (!code.trim()) {
      toast.error("Per favore inserisci il tuo codice studio.");
      return;
    }

    setLoading(true);
    
    try {
      const user = auth.currentUser;
      if (!user) {
        throw new Error("You must be logged in to join an organization.");
      }

      const token = await user.getIdToken();
      const response = await fetch(`${API_BASE_URL}/api/v1/users/register-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ organizationCode: code }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to join organization.');
      }

      const result = await response.json();
      
      toast.success(`Successfully joined ${result.organization_name}!`);
      setLoading(false);
      
      // Immediate navigation after success
      setTimeout(() => {
        try {
          window.location.href = '/';
        } catch (error) {
          console.error('Navigation failed:', error);
          // Try alternative method
          window.location.replace('/');
        }
      }, 500);
      
      // Fallback navigation after 2 seconds
      setTimeout(() => {
        if (window.location.pathname !== '/') {
          try {
            window.location.href = '/';
          } catch (error) {
            console.error('Fallback navigation failed:', error);
            window.location.replace('/');
          }
        }
      }, 2000);
      
    } catch (err: any) {
      toast.error(err.message);
      setLoading(false);
    }
  };
  
  const handleSkip = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Entra nel tuo Studio</CardTitle>
          <CardDescription>
            Inserisci il codice per entrare nel tuo Studio.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="org-code">Codice</Label>
            <Input 
              id="org-code" 
              placeholder="ORG-ABCDE123" 
              value={code}
              onChange={(e) => setCode(e.target.value)}
              disabled={loading}
              onKeyPress={(e) => {
                if (e.key === 'Enter' && !loading) {
                  handleSubmitCode();
                }
              }}
            />
          </div>
          <Button onClick={handleSubmitCode} disabled={loading} className="w-full">
            {loading ? 'Stai entrando...' : 'Unisciti'}
          </Button>
          <Button variant="link" onClick={handleSkip} className="w-full">
            Lo faccio dopo
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
